<template>
	<div class="uk-width-expand@m">
		<div class="bb-options">
			<div class="uk-child-width-1-2" uk-grid>
				<div>
					<div class="bb-option">
						<p class="label">Headboard: <InfoIcon slug="additions-headboard" /></p>
						<div class="input-radios">
							<div class="input"
								v-for="price in depth_prices"
								:class="{'popular' : price.is_popular}"
								:key="price.id">
								<label>
									<input type="radio" class="uk-radio" name="headboard"
										:id="`headboard-${price.id}`"
										:value="price.id"
										v-model="local_headboard"> {{ price.name }} <span v-if="priceIncreases(price)">(+{{price.price | wholeNumber}})</span>
								</label>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="bb-option">
						<p class="label">Desk/Table: <InfoIcon slug="additions-desk-table" /></p>
						<div class="input-radios">
							<div class="input">
								<label>
									<input type="radio" class="uk-radio" v-model="local_desktable" name="desk" :value="null"> None</label>
							</div>
							<div class="input"
								v-for="option in filterPanelOptions"
								:class="{'popular' : option.popular}"
								:key="option.id">
								<label>
									<input type="radio" class="uk-radio" name="desk"
									:id="`desktable-${option.id}`" :value="option.id" v-model="local_desktable"> {{ option.front_panel_type.name }} <span v-if="priceIncreases(option)">(+${{option.price | wholeNumber }})</span></label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- additional options -->
			<div class="bb-option">
				<p class="label">Additional Options: <InfoIcon slug="additions-additional-options" /></p>
				<div class="input-radios">
					<div class="input"
						v-for="option in filteredAdditionalOptions"
						:key="option.id"
						:class="{'popular' : option.is_popular}">
						<label>
							<input type="checkbox" class="uk-checkbox" v-model="local_selected" :name="`additional-${option.id}`" :value="option.id"> {{ option.name }} (${{ option.wallbed_upcharge | wholeNumber }})
						</label>
					</div>
				</div>
			</div>
		</div>
		<NextButtons
			prev_route="wood-finish"
			next_route="left_cabinet" />
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import NextButtons from '../components/NextButtons.vue';
	import InfoIcon from '../components/InfoIcon.vue';
	export default {
		name : 'additions-view',
		components: {
			NextButtons,
			InfoIcon
		},
		data(){ 
			return {
				local_headboard : null,
				local_desktable : null,
				local_selected : [],
			}
		},
		mounted(){
			this.handleSelectedOptions();
			if(this.selected_headboard != null){
				setTimeout(() => document.getElementById(`headboard-${this.selected_headboard.id}`).click(),0);
			}
			if(this.selected_desk_table != null){
				setTimeout(() => document.getElementById(`desktable-${this.selected_desk_table.id}`).click(),0);
			}

			if(this.selected_options.length > 0){
				setTimeout(() => this.handleSelectedOptions(),0);
			}
		},
		methods : {
			/**
			 * check if the item price is greater than zero
			 * @param  {[type]} price [description]
			 * @return {[type]}       [description]
			 */
			priceIncreases(price){
				return price.price > 0 ;
			},
			handleSelectedOptions(){
				let selected = [];
				this.selected_options.forEach(row => {
					selected.push(row.id);
				});
				this.local_selected = selected;
			},
		},
		computed : {
			/**
			 * look through the selected blue print to see
			 * what desk/table options are available
			 * @return {[type]} [description]
			 */
			filterPanelOptions(){
				let options = [];
				this.desk_table_options.forEach(row => {
					let id = row.front_panel_id;
					// loop through size blue prints to see if available.
					let found = false;
					for(let i in this.selected_size.blueprints){
						if(id == this.selected_size.blueprints[i].front_panel_type_id){
							found = true;
							break;
						}
					}
					if(found) options.push(row);
				});
				return options;
			},
			/**
			 * loop through options and verify that the selected headboard size
			 * allows form them
			 * @return {[type]} [description]
			 */
			filteredAdditionalOptions(){
				let options = [];
				this.additional_options.forEach(row => {
					let found = false;
					for(let i in row.depths){
						if(row.depths[i].id == this.selected_headboard.depth_id){
							found = true;
							break;
						}
					}
					if(row.name == 'Studio Desk'){
						found = false;
					}
					if(found) options.push(row);
				});
				return options;
			},
			...mapState({
				selected_headboard :  state => state.selected_headboard,
				selected_desk_table : state => state.selected_desk_table,
				depth_prices : state => state.depth_prices,
				desk_table_options : state => state.desk_table_options,
				additional_options : state => state.additional_options,
				selected_size : state => state.selected_size,
				selected_options : state => state.selected_options
			})
		},
		watch : {
			/**
			 * when depth prices are loaded
			 * make first one selected.
			 * @return {[type]} [description]
			 */
			depth_prices(){
				this.local_headboard = this.depth_prices[0].id;
				setTimeout(() => document.getElementById(`headboard-${this.local_headboard}`).click(),0);
			},
			/**
			 * when the id for the selected headboard changes
			 * find depth_prices row that matches and send it to store
			 * @return {[type]} [description]
			 */
			local_headboard(){
				for(let i in this.depth_prices){
					let price = this.depth_prices[i];
					if(price.id == this.local_headboard){
						this.$store.commit('setSelectedHeadboard',price);
						break;
					}
				}
			},
			/**
			 * get options id and match to option objects
			 * then send that list to store.
			 * @return {[type]} [description]
			 */
			local_desktable(){
				if(this.local_desktable == null){
					this.$store.commit('setSelectedDeskTable',null);
					return;
				}
				// loop through and find by id.
				for(let i in this.desk_table_options){
					let row = this.desk_table_options[i];
					if(row.id == this.local_desktable){
						this.$store.commit('setSelectedDeskTable',row);
						break;
					}
				}
			},
			/**
			 * get options id and match to option objects
			 * then send that list to store.
			 * @return {[type]} [description]
			 */
			local_selected(){
				let options = [];
				for(let i in this.additional_options){
					let row = this.additional_options[i];
					let found = this.$options.filters.inArray(row.id,this.local_selected);
					if(found){
						options.push(row);
					}
				}
				this.$store.commit('setSelectedAdditionalOptions',options);
			},
			/**
			 * when the selected size changes
			 * loop through desk/table options to see match what is available
			 * @return {[type]} [description]
			 */
			selected_size(){
				this.filterPanelOptions();
			},
			/**
			 * when the list of available options changes
			 * check that all the selected options are still available
			 * if not removed it
			 * @return {[type]} [description]
			 */
			filteredAdditionalOptions(){
				let selected = [];
				this.filteredAdditionalOptions.forEach(row => {
					if(this.local_selected.indexOf(row.id) !== -1){
						selected.push(row.id);
					}
				});
				this.local_selected = selected;
			}
		}
	}
</script>